import { useMemo } from "react";
import { createBrowserRouter, RouterProvider } from "react-router";
import { wrapCreateBrowserRouterV7 } from "@sentry/react";
import { SplashScreen } from "@/components";
import { routes } from "./index";

const sentryRouter = wrapCreateBrowserRouterV7(createBrowserRouter);

export const AppRouter = () => {
  const router = useMemo(() => sentryRouter(routes), []);

  return router ? <RouterProvider router={router} /> : <SplashScreen active />;
};
